import { HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ApplicationService } from '../services';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  headerAdded = false; // for testing purposes
  applicationService = inject(ApplicationService);

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    if (this.applicationService.isAdmin()) {
      const authReq = req.clone({
        headers: req.headers.set('Authorization', `Bearer ${this.applicationService.accessToken()}`),
      });
      this.headerAdded = true;
      return next.handle(authReq);
    }
    return next.handle(req);
  }
}
